import React, {ChangeEvent, useCallback, useEffect, useState} from "react";
import { useHistory } from "react-router-dom";

import { Button, Form, Nav, Site, Text } from "tabler-react";

import {StoreData, useAuth} from "../hooks/AuthContext";
import { ApiFidegg } from "../services/apiFideggAdmin";
import { Alerta } from "../utils/Alerta";

const SiteHeader = () => {
  const history = useHistory();

  const { signOut, store, signIn } = useAuth();

  const [stores, setStores] = useState<StoreData[]>();
  const [backUpStores, setbackUpStores] = useState<StoreData[]>([]);
  const [selected, setSelected] = useState<number>(store?.id!);

  function handleSignOut() {
    try {
      signOut();
      history.push(store?.isMonitor ? "/login-monitor" : "/");
    } catch (err) {
      Alerta("Erro ao efetuar logout");
    }
  }

  const getAllStores = useCallback(async () => {
    if (!store || !store.isMonitor) return;

    const storeList = await ApiFidegg.monitor.getStores()
    if (storeList) {
      setStores(storeList)
      setbackUpStores(storeList);
      setSelected(store?.id!);
    }
  }, [store, setbackUpStores, setStores]);

  useEffect(() => {
    getAllStores();
  }, [getAllStores]);

  function handleNameChange(event: ChangeEvent<HTMLInputElement>) {
    let storesFilter = backUpStores?.filter((e) =>
      e.name && e.name
        .toLocaleLowerCase()
        .includes(event.target.value.toLocaleLowerCase())
    );

    if (!storesFilter && event.target.value) {
      setStores([{ id: 1, name: 'Nenhuma Loja encontrada' }]);
    } else {
      setStores(storesFilter);
    }

    setSelected(
      storesFilter.length > 0 && typeof storesFilter[0].id === "number"
        ? storesFilter[0].id
        : -1
    );
    if (event.target.value.length === 0) {
      setSelected(store?.id!);
    }
  }

  function handleChangeSelected(event: ChangeEvent<HTMLSelectElement>) {
    const { value } = event.target;
    return setSelected(parseInt(value));
  }

  async function handleSignInStore(value: number) {
    await signIn({
      id: value,
      isMonitor: true,
    });
    window.location.reload();
  }

  return (
    <Site.Header
      href="/"
      alt="Fidegg"
      imageURL="/img/logo.svg"
      navItems={[
        <Nav.Item link={false} className="mr-5" key="name">
          {Array.isArray(stores) && stores.length > 0 ? (
            <Form
              onSubmit={(e) => {
                e.preventDefault();
                handleSignInStore(selected);
              }}
            >
              <Form.InputGroup style={{ width: "30rem" }}>
                <Form.Select
                  style={{ height: "31px" }}
                  className="form-control-sm"
                  onChange={handleChangeSelected}
                  value={selected}
                >
                  {stores.map((store) => (
                    <option value={store?.id} key={store?.id}>
                      {store?.name}
                    </option>
                  ))}
                </Form.Select>
                <Form.Input
                  className="form-control-sm"
                  placeholder="Nome"
                  name="name"
                  onChange={handleNameChange}
                />
                <span className="input-group-btn ml-2">
                  <Button
                    size="sm"
                    color="default"
                    type="submit"
                    icon="search"
                  />
                </span>
              </Form.InputGroup>
            </Form>
          ) : (
            <Text>{store?.name}</Text>
          )}
        </Nav.Item>,
        <Nav.Item link={false} className="d-none d-md-flex" key="logout">
          <Button
            href="#"
            outline
            size="sm"
            RootComponent="a"
            color="primary"
            pill
            onClick={handleSignOut}
          >
            Sair
          </Button>
        </Nav.Item>,
      ]}
    />
  );
};

export default SiteHeader;
